import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { Icon, Tag } from '@fourthwall/components'

import * as S from './styled'
import type { SettingsMenuItemProps } from './types'

export const SettingsMenuItem = ({
  label,
  icon,
  activeIcon,
  to,
  tag,
  items,
}: SettingsMenuItemProps) => {
  const location = useLocation()
  const matched = useMemo(() => {
    return location.pathname === to || location.pathname.startsWith(`${to}/`)
  }, [location.pathname, to])

  const hasChildren = !!items?.length
  const shouldShowChildren = useMemo(() => {
    return hasChildren && (matched || (items || []).some((item) => location.pathname === item.to))
  }, [hasChildren, matched, items, location.pathname])

  return (
    <S.Container>
      <S.Link to={to} $active={matched}>
        <S.Wrapper>
          {icon ? (
            <Icon component={matched ? activeIcon || icon : icon} height={16} />
          ) : (
            <S.Spacer />
          )}
          <S.Label>{label}</S.Label>
          {tag && (
            <S.TagWrapper>
              <Tag label={tag} appearance="strong" />
            </S.TagWrapper>
          )}
        </S.Wrapper>
      </S.Link>
      {shouldShowChildren && (
        <S.ChildrenContainer>
          {(items || []).map((item) => (
            <SettingsMenuItem key={item.label} label={item.label} to={item.to} tag={item.tag} />
          ))}
        </S.ChildrenContainer>
      )}
    </S.Container>
  )
}
